import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { RequireAuth } from '@/components/RequireAuth';
import { RootRedirect } from '@/components/RootRedirect';
import { useAuthStore } from '@/stores/useAuthStore';

import { LoginPage } from '@/pages/LoginPage';
import { SignupPage } from '@/pages/SignupPage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { ResetPasswordPage } from '@/pages/ResetPasswordPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { FindOrgPage } from '@/pages/FindOrgPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { MyRequestsPage } from '@/pages/MyRequestsPage';
import { OrgApprovalsPage } from '@/pages/OrgApprovalsPage';
import { MfaChallengePage } from '@/pages/MfaChallengePage';
import { MfaSetupPage } from '@/pages/MfaSetupPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export function App() {
  const bootstrap = useAuthStore((s) => s.bootstrap);
  const loading = useAuthStore((s) => s.loading);

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        로딩 중...
      </div>
    );
  }

  return (
    <Routes>
      {/* 공개 */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* MFA — login challenge 는 인증 전, setup 은 인증 후 (mfa_pending 토큰으로 접근) */}
      <Route path="/mfa/challenge" element={<MfaChallengePage />} />
      <Route
        path="/mfa/setup"
        element={
          <RequireAuth>
            <MfaSetupPage />
          </RequireAuth>
        }
      />

      {/* 인증 필요 */}
      <Route
        path="/"
        element={
          <RequireAuth>
            <RootRedirect />
          </RequireAuth>
        }
      />
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <DashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/find-org"
        element={
          <RequireAuth>
            <FindOrgPage />
          </RequireAuth>
        }
      />
      <Route
        path="/profile"
        element={
          <RequireAuth>
            <ProfilePage />
          </RequireAuth>
        }
      />
      <Route
        path="/my-requests"
        element={
          <RequireAuth>
            <MyRequestsPage />
          </RequireAuth>
        }
      />
      {/* Phase 5c: org_admin 의 가입 요청 승인 — 라우트는 모든 인증자에 열어두고 페이지 내부에서 admin orgs 0 이면 안내 */}
      <Route
        path="/approvals"
        element={
          <RequireAuth>
            <OrgApprovalsPage />
          </RequireAuth>
        }
      />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

// re-export to ensure default routes resolve
void Navigate;
